import afterHookLayout from './afterHookLayout';
import store from '@/store';

const afterHook = (to, from) => {
	if (process.env.NODE_ENV !== 'production')
		if (to.path !== from.path)
			//console.log('After Route: ', { from, to });

			store.dispatch('closeMenu');

	afterHookLayout(to, from);
};

export default afterHook;
